<!--
 * @Author: qinjing 18137813334@163.com
 * @Date: 2023-08-28 10:20:50
 * @LastEditors: qinjing 18137813334@163.com
 * @LastEditTime: 2023-08-28 11:05:08
 * @FilePath: \hkmc-h5\src\views\activity\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="qualification-cash-page">
        <img class="img" src="../../assets/img/qualificationCash.png" />
    </div>
</template>

<script>
export default {
    name: 'QualificationCash'
}
</script>

<style scoped>
    .qualification-cash-page {
        width: 100%;
        height: 100vh;
        margin: 0 auto;
        background: rgb(28, 50, 255);
    }
    .img {
      display: block;
      width: 100%;
    }
</style>
